import { useIntl } from 'react-intl';
import RecoverPassword from '../../assets/target/images/RecoverPassword.png';
import Button from '../../components/Button';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { t } from '../../lang';

import './RecoveryPassword.scss';

const { supportBotName } = AppConfig;

const RecoveryPassword = () => {
	const intl = useIntl();

	return (
		<>
			<PageHeader />
			<div className='RecoveryPassword'>
				<img className='RecoveryPassword-img' src={RecoverPassword} />

				<div className='RecoveryPassword-content'>
					<div className='title'>{t('Password recovery')}</div>
					<div className='text'>
						{t('The only way to recover your wallet is to complete the recovery procedure through Support')}
					</div>
					<div className='text'>
						{t('Send a request and follow the instructions provided in {supportBotName}', {
							supportBotName: supportBotName,
						})}
					</div>
				</div>
				<Button styleType='primary' onClick={() => alert(intl.formatMessage({ id: 'The bot wasn’t created' }))}>
					{t('Send a request')}
				</Button>
			</div>
		</>
	);
};

export default RecoveryPassword;
